<template>
    <li class="list-inline-item">
        <!-- Notification -->
        <div class="notification-box">
            <ul class="list-inline m-b-0">
                <li>
                    <a href="javascript:void(0);" class="right-bar-toggle">
                        <i class="zmdi zmdi-notifications-none"></i>
                    </a>
                    <div class="noti-dot">
                        <span class="dot"></span>
                        <span class="pulse"></span>
                    </div>
                </li>
            </ul>
        </div>
        <!-- End Notification bar -->
    </li>
</template>

<script>
export default {
    name: "Notifications",
};
</script>

<style scoped>

</style>